import isValidAnswer from '@opsbase/lib-form/helpers/isValidAnswer';
import { safeParseFloat } from '@opsbase/lib-general/utils/safeParseFloat';
import { flagColor } from '@opsbase/lib-issue/Flag';
import React, { useContext } from 'react';
import DetailsReportSwab from '../DetailsReportSwab';
import DetailsOpReportAnswerCell from './DetailsOpReportAnswerCell';
import { DetailsOpReportQuestionContext } from './DetailsOpReportQuestion';
export function DetailsOpReportAnswerNumber() {
    const { a, q, r } = useContext(DetailsOpReportQuestionContext);
    const right = false;
    // If answered
    if (isValidAnswer(a, q, r)) {
        const v = safeParseFloat(a.value);
        const lt = r.lessThan;
        const mt = r.moreThan;
        const isLessThan = lt && (lt === null || lt === void 0 ? void 0 : lt.value) !== '' && v < safeParseFloat(lt === null || lt === void 0 ? void 0 : lt.value);
        const isMoreThan = mt && mt.value !== '' && v > safeParseFloat(mt === null || mt === void 0 ? void 0 : mt.value);
        let color;
        if (isLessThan)
            color = flagColor(lt === null || lt === void 0 ? void 0 : lt.flag);
        if (isMoreThan)
            color = flagColor(mt === null || mt === void 0 ? void 0 : mt.flag);
        return (React.createElement(DetailsOpReportAnswerCell, { right: right },
            React.createElement(DetailsReportSwab, { color: color }),
            v));
    }
    // Otherwise
    else {
        return React.createElement(DetailsOpReportAnswerCell, { right: right }, "- - -");
    }
}
export default DetailsOpReportAnswerNumber;
